import type { PermissionPath } from '../hooks/usePermissions';

// Order the more specific routes before their containing pages.
const rules: [RegExp, PermissionPath][] = [
  [/^\/vehicles\/[^/]+\/documents(?:\/|$)|^\/vehicles\/documents$/, 'documents.view'],
  [/^\/vehicles\/maintenance-unavailable$/, 'maintenance.view'],
  [/^\/vehicles\/sales$/, 'vehicleSales.view'],
  [/^\/vehicles\/settings$/, 'settings.view'],
  [/^\/vehicles\/add$/, 'vehicles.create'],
  [/^\/vehicles\/[^/]+\/edit$/, 'vehicles.edit'],
  [/^\/vehicles(?:\/|$)/, 'vehicles.view'],
  [/^\/quotations(?:\/|$)/, 'quotations.view'],
  [/^\/contracts(?:\/|$)/, 'contracts.view'],
  [/^\/invoices(?:\/|$)/, 'invoices.view'],
  [/^\/booking-settings$/, 'bookingSettings.view'],
  [/^\/bookings(?:\/|$)/, 'bookings.view'],
  [/^\/clients(?:\/|$)/, 'customers.view'],
  [/^\/revenue\/credit$/, 'credits.view'],
  [/^\/revenue\/cassie$/, 'cashDrawer.view'],
  [/^\/revenue\/lease$/, 'leases.view'],
  [/^\/revenue$/, 'revenue.view'],
  [/^\/bank$/, 'bank.view'],
  [/^\/expenses$/, 'expenses.view'],
  [/^\/incomes$/, 'incomes.view'],
  [/^\/calendar$/, 'calendar.view'],
  [/^\/radar(?:\/|$)/, 'radar.view'],
  [/^\/analytics$/, 'analytics.view'],
  [/^\/employees$/, 'employees.view'],
  [/^\/roles$/, 'roles.view'],
  [/^\/tasks$/, 'tasks.view'],
  [/^\/subscription$/, 'subscription.view'],
  [/^\/support(?:\/|$)/, 'support.view'],
  [/^\/pos\/handover$/, 'pos.handover'],
  [/^\/pos\/return$/, 'pos.return'],
  [/^\/pos\/bookings(?:\/|$)/, 'bookings.view'],
  [/^\/pos(?:\/|$)/, 'pos.access'],
  [/^\/dashboard$/, 'dashboard.view'],
];

export function pagePermission(pathname: string, search = ''): PermissionPath | undefined {
  if (pathname === '/pos/full-booking') return new URLSearchParams(search).has('upgrade') ? 'bookings.edit' : 'bookings.create';
  return rules.find(([pattern]) => pattern.test(pathname))?.[1];
}
